"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Search = function (props) {
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    return (react_1.default.createElement("div", { className: "__alphabet-wrap-input" },
        react_1.default.createElement("input", { onChange: function (e) { return props.onChange(e.target.value); }, placeholder: t("page.index.list.search.placeholder"), className: "__alphabet-input-search" }),
        react_1.default.createElement("img", { alt: "search", style: { height: "40px", width: "36px" }, className: "__alphabet-input-search-icon", src: "/images/web/search.svg" })));
};
exports.default = Search;
